module.exports = __webpack_public_path__ + "static/media/81567d9d-50c3-4e5d-b0b4-dcf4403c0391_1.33e524509c306c71ee13a18f4ac5cf8b.6cfe110c.jpeg";